<template>
  <div id="m-mobile-zxns">
    <img src="../../../assets/mobile/5.png" width="100%">
    <div class="sj1">
      <div>
        <div id="div_job1" class="s1_main">
          <div class="s1_list" v-for="item in EmploysData1">
            <div class="top1" headerindex="0h">
              <span class="accordprefix"></span>{{item.frecruitmentPost}}
              <span class="accordsuffix"></span>
            </div>
            <div class="main" contentindex="0c" style="display: none;">
              <div class="two">
                <div class="wrap" v-html="item.fjobContent">
                </div>
                <div class="wrap" v-html="item.fjobRequirements">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "../../../../static/js/commonAxios";
  import $ from "jquery";

  export default {
    name: "mobileEmploys",
    data(){
      return{
        EmploysData1: [],
        EmploysData2: []
      }
    },
    mounted(){
      this.getEmploysData()
    },
    methods: {
      // 获取招聘信息
      getEmploysData(){
        axios.get('/api/recruitList').then((res) => {
          if(res.data.success){
            let Sarr = []
            let Yarr = []
            if(res.data.items){
              res.data.items.forEach((ele) => {
                if(ele.frecruitType ==='S'){
                  Sarr.push(ele)
                }else {
                  Yarr.push(ele)
                }
              })
            }
            this.EmploysData1 = Sarr
            this.EmploysData2 = Yarr
            this.$nextTick(()=>{
              $(document).ready(function () {
                $(".nav li:nth-child(5)").find("a").addClass("active");
              });
              $(function () {
                $(".s1_list .top1").focus(function () { this.blur(); });
              })
              ddaccordion.init({
                headerclass: "top1",  //标题
                contentclass: "main", //内容
                revealtype: "click",
                mouseoverdelay: 0,
                collapseprev: true,
                defaultexpanded: [0], //默认展开第几个,从0开始
                onemustopen: false,
                animatedefault: false,
                persiststate: true, //默认开启：false
                toggleclass: ["", "active"],//点击过后样式
                togglehtml: ["suffix", ""],
                oninit: function (headers, expandedindices) {
                },
                onopenclose: function (header, index, state, isuseractivated) {
                }
              })
            })
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
    },
  }
</script>

<style>
  #m-mobile-zxns {
    margin-top: 3.25rem;
  }
  #m-mobile-zxns .sj1{
    box-sizing: border-box;
   width: 100%;
    padding: 2rem 1.9rem;
   /*padding-top: 65px;*/
   /*padding-bottom: 65px;*/
   background: #fff;
 }
  #m-mobile-zxns .sj1 .s1_main{
   width: 100%;
   /*margin-top: 60px;*/
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list{
   width: 100%;
   /*margin-bottom: 10px;*/
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .top1{
   /*width: 1140px;*/
    margin: 0.3rem 0;
   padding-left: 1rem;
   height: 2.7rem;
   line-height: 2.7rem;
   font-size: 1rem;
   color:#333;
   background: url(../../../assets/52.png) no-repeat 1140px center #f7f7f7;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .active{
   background: url(../../../assets/53.png) no-repeat 1140px center #8ec31f;
   color: #fff;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main{
    box-sizing: border-box;
   /*width: 1080px;*/
   padding: 1.34rem 1rem;
   /*background: #f7f7f7*/
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .one{
   width: 100%;
   padding-bottom: 20px;
   border-bottom: 1px dashed #ccc
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .one li{
   width: 360px;
   line-height: 30px;
   float: left;
   font-size: 14px;
   color: #da251d;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .one li span{
   color: #666;
   margin-left: 20px;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .two{

 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .two .wrap{
   width: 100%;
   margin-bottom: 25px;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .two .wrap h2{
   color: #333;
   font-weight: bold;
   font-size: 14px;
   line-height: 30px;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .two .wrap div{
   font-size: 14px;
   color: #666;
   line-height: 30px;
 }
  #m-mobile-zxns .sj1 .s1_main .s1_list .main .two h3{
   color: #da251d;
   font-size: 14px;
   line-height: 30px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/mobileEmploys/mobileEmploys.vue